import { LineImageAlt } from '@qr-front/icons/line-image-alt'
import { fieldLabelCls } from '@qr-front/ui/components/InputField'
import { FileUploadToMediaStorage } from 'components/FileUploadToMediaStorage'
import { useAtom, useSetAtom } from 'jotai'
import { atomWithReset, RESET } from 'jotai/utils'
import { useTranslations } from 'next-intl'
import { useBus } from 'react-bus'

import { TUploadedMedia } from '@/services'
import { getStore } from '@/store'

// 5MB
const MAX_FILE_SIZE = 5 * 1024 * 1024

export const customSocialImageAtom = atomWithReset<TUploadedMedia | null>(null)
export const customSocialImageFileAtom = atomWithReset<File | null>(null)

export const CUSTOM_SOCIAL_IMAGE_UPLOAD_STARTED =
	'customSocialImageUploadStarted'
export const CUSTOM_SOCIAL_IMAGE_UPLOAD_FINISHED =
	'customSocialImageUploadFinished'

export const resetCustomSocialImagesField = () => {
	getStore().set(customSocialImageAtom, RESET)
	getStore().set(customSocialImageFileAtom, RESET)
}

export const CustomSocialImageUpload = () => {
	const t = useTranslations()
	const bus = useBus()

	const setCustomSocialImage = useSetAtom(customSocialImageAtom)
	const [file, setFile] = useAtom(customSocialImageFileAtom)

	const fileUploadTranslations = {
		title: t('generator__content_form_section__social__upload_image'),
		caption: t('generator__content_form_section__social__max_image_size', {
			size: MAX_FILE_SIZE / 1024 / 1024,
		}),
		deleteButtonLabel: t('ui__file_upload__delete_button'),
		unsupportedFormatErrorMessage: t(
			'ui__file_upload__unsupported_format_error',
		),
		sizeTooLargeErrorMessage: t('ui__file_upload__file_size_error', {
			maxSize: MAX_FILE_SIZE / 1024 / 1024,
		}),
	}

	const cropDialogTranslations = {
		zoom: t('ui__image_crop_dialog__zoom'),
		closeButton: t('ui__popup__close_button'),
		saveButton: t('ui__image_crop_dialog__save_button'),
	}

	return (
		<div>
			<label className={fieldLabelCls}>
				{t(
					'generator__content_form_section__social__add_social__image',
				)}
			</label>
			<FileUploadToMediaStorage
				uploadPurpose="content_image"
				initialFileList={file ? [file] : []}
				onUploadStart={() => {
					bus.emit(CUSTOM_SOCIAL_IMAGE_UPLOAD_STARTED)
				}}
				onUploadComplete={(
					uploaded: TUploadedMedia,
					original: File,
				) => {
					setCustomSocialImage(uploaded)
					setFile(original)
					bus.emit(CUSTOM_SOCIAL_IMAGE_UPLOAD_FINISHED)
				}}
				onDelete={() => {
					setCustomSocialImage(null)
					setFile(null)
					bus.emit(CUSTOM_SOCIAL_IMAGE_UPLOAD_FINISHED)
				}}
				resizeResolution={{ width: 2048, height: 2048 }}
				maxFileSize={MAX_FILE_SIZE}
				placeholderIcon={<LineImageAlt />}
				showCropDialog
				cropDialogTranslations={cropDialogTranslations}
				translations={fileUploadTranslations}
				className="mt-2"
			/>
		</div>
	)
}
